import React, { Component, Fragment } from "react";
import "moment/locale/fr";
import { Link } from "react-router-dom";

import Requests from "./Requests";
import List from "../../../components/list/List";
import Pagination from "./PaginationContainer";
import IndicatorBanner from "../../../components/indicators/IndicatorBanner";
import Filter from "./FilterContainer";
import { Icon } from "antd";
import { getContactsFile, getPdcsFile } from "./pdcs.utils/exportFiles";
import Strates from "./pdcs.utils/activeRanges";

const COLUMNS = [
  {
    title: "ID",
    key: "pdc_id",
    sortable: true
  },
  {
    title: "Nom",
    key: "pdc_label",
    sortable: true
  },
  {
    title: "secteur",
    key: "sectors",
    render: (text, record, index) => {
      const sectors = record.sectors || [];
      return (
        <Fragment key={index}>
          {sectors.map((sector, i) => (
            <div key={i} style={{ marginBottom: 2 }}>
              <span>
                {sector.client_label} : {sector.sector_label}
              </span>
            </div>
          ))}
        </Fragment>
      );
    }
  },
  {
    title: "Enseigne",
    key: "retailer_label",
    sortable: true
  },
  {
    title: "Enseigne ID",
    key: "retailer_id",
    sortable: true
  },
  {
    title: "Typologie",
    key: "typology_label",
    sortable: true
  },
  {
    title: "Adresse",
    key: "address"
  },
  {
    title: "Code Postal",
    key: "cp"
  },
  {
    title: "Ville",
    key: "city"
  },
  {
    title: "Réseau",
    key: "network_label"
  },
  {
    title: "Strates ID",
    render: (text, record, index) => {
      return (
        <Fragment key={record.pdc_id}>
          <Strates pdcId={record.pdc_id}></Strates>
        </Fragment>
      );
    }
  },
  {
    title: "Actions",
    key: "actions",
    sortable: false,
    render: (text, record, index) => {
      return (
        <Fragment key={index}>
          <span>
            <Link
              to={{
                pathname: `/basepdc/detail/${record.pdc_id}`
              }}
            >
              <Icon type="eye"></Icon>
            </Link>
          </span>
        </Fragment>
      );
    }
  }
];
class PdcsList extends Component {
  state = { sortOrder: true, mounted: false };

  componentDidMount() {
    this.props.init();
  }
  render() {
    const listData_banner = Object.keys(this.props.listBanner).map(key => {
      return { label: key, value: this.props.listBanner[key] };
    });

    const columns = COLUMNS.map(column => {
      let newColumn = {
        title: column.title,
        dataIndex: column.key,
        key: column.key
      };
      if (column.sortable) {
        newColumn.onHeaderCell = () => {
          return {
            onClick: () => {
              this.setState({ sortOrder: !this.state.sortOrder }, () => {
                this.state.sortOrder ? this.props.setSort(column.key, 1) : this.props.setSort(column.key, -1);
              });
            }
          };
        };
        newColumn.sorter = () => 0;
      }
      if (column.render) {
        newColumn.render = column.render;
      }
      return newColumn;
    });

    return (
      <Fragment>
        <div className="p-content-page-center">
          <div className="p-content-page-center-header">
            <div className="p-flex p-al-v-center">
              <h2 className="p-content-page-center-header-title">Base PDC</h2>
              <Requests token={this.props.token} currentClientId={this.props.currentClient} />
            </div>
            <div className="p-content-page-center-header-buttons">
              <Link to={"/ref/retailers"} target="_blank">
                <span
                  className={`p-btn p-btn-blue p-mrg-left-s flex flex-col items-center items-center justify-center`}
                >
                  <div className="text-white">Liste des enseignes + export des contacts par enseigne</div>
                  <div className="text-white">(dont plus de 300 non reliées à un point de vente)</div>
                </span>
              </Link>
              <div className="p-content-page-center-header-buttons-item p-flex">
                <div
                  onClick={async () => {
                    const { currentClient, token } = this.props;
                    try {
                      getContactsFile(currentClient, token);
                    } catch (e) {
                      console.log("error", e);
                    }
                  }}
                  className="p-btn p-btn-orange p-mrg-right"
                >
                  Export contacts
                </div>
                <div
                  onClick={async () => {
                    const { currentFilters, token } = this.props;
                    try {
                      getPdcsFile(currentFilters, token);
                    } catch (e) {
                      console.log("error", e);
                    }
                  }}
                  className="p-btn p-btn-green"
                >
                  Export pdcs
                </div>
              </div>
            </div>
          </div>
          <div className="p-content-page-center-filters" style={{ alignItems: "center" }}>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"pdc_id"}
                placeholder={"pdc id"}
                defaultValue={this.props.currentFilters["pdc_id"]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"pdc_label"}
                placeholder={"Recherche pdc"}
                defaultValue={this.props.currentFilters["pdc_label"]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"retailer_label"}
                placeholder={"Enseigne"}
                defaultValue={this.props.currentFilters["retailer_label"]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter filterTargetKey={"city"} placeholder={"Ville"} defaultValue={this.props.currentFilters["city"]} />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"zip_code"}
                placeholder={"Code postal"}
                defaultValue={this.props.currentFilters["zip_code"]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"network_label"}
                placeholder={"Réseaux"}
                defaultValue={this.props.currentFilters["network_label"]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"sectors.client_id"}
                placeholder={"Actif"}
                checkbox={true}
                defaultValue={this.props.currentFilters["sectors.client_id"]}
              />
            </div>
          </div>
          <div className="p-content-page-center-content">
            <List data={this.props.pdcs} page={this.props.currentPage} pages={this.props.totalPage} columns={columns} />
            <div className="p-al-right p-mrg-ver">
              <Pagination />
            </div>
          </div>
        </div>

        <div className="p-content-page-right">
          <h3 className="p-content-page-right-title">Indicateurs du dossier:</h3>
          <IndicatorBanner size="small" items={listData_banner} />
        </div>
      </Fragment>
    );
  }
}

export default PdcsList;



// WEBPACK FOOTER //
// src/containers/metier/pdcs/PdcsList.js